
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.344","height":"17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon feather-heart","d":"M17.43 1.915a4.827 4.827 0 00-6.828 0l-.93.93-.93-.93a4.828 4.828 0 00-6.828 6.828l.93.93 6.828 6.83 3.015-3.015 3.812-3.812.93-.93a4.827 4.827 0 000-6.828z","fill":"none","stroke":"#727272","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    